"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8186],{

/***/ 10712:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _usr_src_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _usr_src_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4730);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11752);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69417);
/* harmony import */ var _API_member__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30940);
/* harmony import */ var _utils_urlHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20253);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18459);
/* harmony import */ var _components_UserProvider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44979);
/* harmony import */ var _utils_AnalyticsHelper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10239);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55252);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);


var _excluded = ["ctaLocation", "pageProperties", "partnerName", "marketingPath"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_usr_src_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var _ref = next_config__WEBPACK_IMPORTED_MODULE_1___default()(),
    publicRuntimeConfig = _ref.publicRuntimeConfig;

var BREEDLOVE_LOGIN_URL = publicRuntimeConfig.BREEDLOVE_LOGIN_URL,
    CORE_BASE_URL = publicRuntimeConfig.CORE_BASE_URL;

var CTAButton = function CTAButton(_ref2) {
  var _auth$member, _auth$member3;

  var ctaLocation = _ref2.ctaLocation,
      pageProperties = _ref2.pageProperties,
      partnerName = _ref2.partnerName,
      marketingPath = _ref2.marketingPath,
      props = (0,_usr_src_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_ref2, _excluded);

  var _useUserAuth = (0,_components_UserProvider__WEBPACK_IMPORTED_MODULE_5__/* .useUserAuth */ .Ii)(),
      auth = _useUserAuth.auth;

  var partnersRx = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_7__/* .getPartnersRXCookie */ .g)();
  var enrollmentUrl = partnerName ? _constants__WEBPACK_IMPORTED_MODULE_4__/* .PARTNER_ENROLLMENT_IN_PROGRESS_URI */ .LE : _constants__WEBPACK_IMPORTED_MODULE_4__/* .ENROLLMENT_IN_PROGRESS_URI */ .TD;
  var buttonState = {
    [_API_member__WEBPACK_IMPORTED_MODULE_2__/* .AccountStatus.Pending */ .d.Pending]: {
      text: 'Continue registration',
      href: "".concat(CORE_BASE_URL).concat(enrollmentUrl)
    },
    [_API_member__WEBPACK_IMPORTED_MODULE_2__/* .AccountStatus.Submitted */ .d.Submitted]: {
      text: 'Approval pending',
      href: "".concat(CORE_BASE_URL).concat(enrollmentUrl)
    },
    [_API_member__WEBPACK_IMPORTED_MODULE_2__/* .AccountStatus.Client */ .d.Client]: {
      text: 'My account',
      href: BREEDLOVE_LOGIN_URL
    },
    [_API_member__WEBPACK_IMPORTED_MODULE_2__/* .AccountStatus.None */ .d.None]: {
      text: 'Get started',
      href: (0,_utils_urlHelper__WEBPACK_IMPORTED_MODULE_3__/* .getEnrollmentUrl */ .JD)(undefined, partnersRx, marketingPath)
    },
    undefined: {
      text: 'Get started',
      href: (0,_utils_urlHelper__WEBPACK_IMPORTED_MODULE_3__/* .getEnrollmentUrl */ .JD)(undefined, partnersRx, marketingPath)
    }
  };

  var handleCtaClick = function handleCtaClick(ctaText) {
    (0,_utils_AnalyticsHelper__WEBPACK_IMPORTED_MODULE_6__/* .logAnalyticsEvent */ .qw)({
      data: {
        cta_location: ctaLocation,
        cta_text: ctaText
      },
      name: _utils_AnalyticsHelper__WEBPACK_IMPORTED_MODULE_6__/* .AmplitudeEventName.ctaInteracted */ .LW.ctaInteracted,
      pageProperties: _objectSpread(_objectSpread({}, pageProperties), {}, {
        partnerName,
        marketingPath
      })
    });
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    href: buttonState[auth === null || auth === void 0 ? void 0 : (_auth$member = auth.member) === null || _auth$member === void 0 ? void 0 : _auth$member.homepayAccountStatusV2].href,
    onClick: function onClick() {
      var _auth$member2;

      return handleCtaClick(buttonState[auth === null || auth === void 0 ? void 0 : (_auth$member2 = auth.member) === null || _auth$member2 === void 0 ? void 0 : _auth$member2.homepayAccountStatusV2].text);
    }
  }, props), {}, {
    children: buttonState[auth === null || auth === void 0 ? void 0 : (_auth$member3 = auth.member) === null || _auth$member3 === void 0 ? void 0 : _auth$member3.homepayAccountStatusV2].text
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (CTAButton);

/***/ }),

/***/ 676:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ EnrollmentCTA_EnrollmentCTA; }
});

// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(5616);
// EXTERNAL MODULE: ./node_modules/@care/material-ui-theme/dist/config/theme/theme.js + 68 modules
var theme = __webpack_require__(5136);
// EXTERNAL MODULE: ./src/API/member.ts
var member = __webpack_require__(30940);
// EXTERNAL MODULE: ./src/components/UserProvider/index.ts + 1 modules
var UserProvider = __webpack_require__(44979);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Card/Card.js
var Card = __webpack_require__(37088);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardContent/CardContent.js + 1 modules
var CardContent = __webpack_require__(44267);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Hidden/Hidden.js + 4 modules
var Hidden = __webpack_require__(50456);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(69417);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 2 modules
var Link = __webpack_require__(23795);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(18459);
// EXTERNAL MODULE: ./src/utils/urlHelper.ts
var urlHelper = __webpack_require__(20253);
// EXTERNAL MODULE: ./src/utils/AnalyticsHelper.ts
var AnalyticsHelper = __webpack_require__(10239);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/pages/shared/EnrollmentCTA/TrustBuildingFlowCard.tsx










var _ref = config_default()(),
    publicRuntimeConfig = _ref.publicRuntimeConfig;

var HOMEPAY_URL = publicRuntimeConfig.HOMEPAY_URL;

var TrustBuildingFlowCard = function TrustBuildingFlowCard(_ref2) {
  var ctaLocation = _ref2.ctaLocation,
      pageProperties = _ref2.pageProperties;
  var theme = (0,useTheme/* default */.Z)();

  var handleAnswer = function handleAnswer(answer) {
    return (0,AnalyticsHelper/* logAnalyticsEvent */.qw)({
      data: {
        enrollment_step: 'Hire status',
        hire_status: answer.text
      },
      name: AnalyticsHelper/* AmplitudeEventName.homePayEnrollmentStarted */.LW.homePayEnrollmentStarted,
      pageProperties: constants/* PAGE_PROPERTIES.mainVHP */.vk.mainVHP
    });
  };

  var handleCaregiverClick = function handleCaregiverClick() {
    (0,AnalyticsHelper/* logAnalyticsEvent */.qw)({
      data: {
        cta_location: "Enrollment CTA - ".concat(ctaLocation),
        cta_text: "I'm a caregiver"
      },
      name: AnalyticsHelper/* AmplitudeEventName.ctaInteracted */.LW.ctaInteracted,
      pageProperties
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Card/* default */.Z, {
    careVariant: "subtle",
    sx: {
      margin: '8px 4px 0 4px',
      minHeight: '205px',
      zIndex: 25,
      [theme.breakpoints.up('sm')]: {
        margin: '15px 0 0',
        minHeight: '166px',
        width: '494px',
        zIndex: 1
      }
    },
    className: constants/* TBF_SECTION_SCROLL_CLASS */.Zq,
    "data-testid": "tbf-card",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
      sx: {
        [theme.breakpoints.down('md')]: {
          padding: theme.spacing(2.5)
        }
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
          marginBottom: theme.spacing(4),
          paddingTop: theme.spacing(2),
          [theme.breakpoints.down('sm')]: {
            marginBottom: 0,
            paddingTop: 0
          }
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* default */.Z, {
          align: "center",
          variant: "h2",
          children: ["To get started, have you hired", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)(Hidden/* default */.Z, {
            xsUp: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})
          }), "a caregiver?"]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        direction: "row",
        spacing: 2,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
          item: true,
          xs: 6,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
            textAlign: "center",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
              sx: {
                textAlign: 'center',
                [theme.breakpoints.down('md')]: {
                  margin: '15px auto 10px',
                  minWidth: 0,
                  width: '100%'
                }
              },
              color: "primary",
              "data-testid": "home-cta-yes-btn",
              href: (0,urlHelper/* getEnrollmentUrl */.JD)(constants/* HIRE_STATUS.yes */.ze.yes),
              onClick: function onClick() {
                return handleAnswer(constants/* HIRE_STATUS.yes */.ze.yes);
              },
              size: "large",
              variant: "contained",
              children: "Yes"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
          item: true,
          xs: 6,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
            textAlign: "center",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
              sx: {
                textAlign: 'center',
                [theme.breakpoints.down('md')]: {
                  margin: '15px auto 10px',
                  minWidth: 0,
                  width: '100%'
                }
              },
              color: "primary",
              "data-testid": "home-cta-not-yet-btn",
              href: (0,urlHelper/* getEnrollmentUrl */.JD)(constants/* HIRE_STATUS.notYet */.ze.notYet),
              onClick: function onClick() {
                return handleAnswer(constants/* HIRE_STATUS.notYet */.ze.notYet);
              },
              size: "large",
              variant: "outlined",
              children: "Not yet"
            })
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
          marginTop: theme.spacing(2.5),
          textAlign: 'center',
          [theme.breakpoints.down('md')]: {
            marginTop: theme.spacing(0.5)
          }
        },
        onClick: handleCaregiverClick,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "".concat(HOMEPAY_URL).concat(constants/* ROUTING_PROPERTIES.caregiver.relativeURL */.ZY.caregiver.relativeURL),
          passHref: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
            underline: "none",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
              color: "secondary",
              variant: "body1",
              children: "I'm a caregiver"
            })
          })
        })
      })]
    })
  });
};

/* harmony default export */ var EnrollmentCTA_TrustBuildingFlowCard = (TrustBuildingFlowCard);
// EXTERNAL MODULE: ./src/components/pages/shared/CTAButton/CTAButton.tsx
var CTAButton = __webpack_require__(10712);
;// CONCATENATED MODULE: ./src/components/pages/shared/EnrollmentCTA/EnrollmentCTA.tsx









var EnrollmentCTA = function EnrollmentCTA(_ref) {
  var _auth$member, _auth$member2;

  var ctaLocation = _ref.ctaLocation,
      pageProperties = _ref.pageProperties;

  var _useUserAuth = (0,UserProvider/* useUserAuth */.Ii)(),
      auth = _useUserAuth.auth;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: !(auth !== null && auth !== void 0 && (_auth$member = auth.member) !== null && _auth$member !== void 0 && _auth$member.homepayAccountStatusV2) || ((_auth$member2 = auth.member) === null || _auth$member2 === void 0 ? void 0 : _auth$member2.homepayAccountStatusV2) === member/* AccountStatus.None */.d.None ? /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
      sx: {
        marginBottom: theme/* theme.spacing */.rS.spacing(1.5),
        justifyContent: 'center',
        display: 'flex',
        [theme/* theme.breakpoints.up */.rS.breakpoints.up('md')]: {
          margin: theme/* theme.spacing */.rS.spacing(0, 0, 4, 0),
          display: 'inline-block',
          justifyContent: 'left'
        }
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(EnrollmentCTA_TrustBuildingFlowCard, {
        ctaLocation: ctaLocation,
        pageProperties: pageProperties
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
      sx: {
        margin: theme/* theme.spacing */.rS.spacing(0, 3, 3, 3),
        [theme/* theme.breakpoints.up */.rS.breakpoints.up('sm')]: {
          margin: theme/* theme.spacing */.rS.spacing(7, 2)
        },
        [theme/* theme.breakpoints.down */.rS.breakpoints.down('md')]: {
          textAlign: 'center'
        }
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CTAButton/* default */.Z, {
        sx: {
          maxWidth: '450px',
          textAlign: 'center',
          width: '100%'
        },
        color: "primary",
        ctaLocation: ctaLocation,
        pageProperties: pageProperties,
        size: "medium",
        variant: "contained"
      })
    })
  });
};

/* harmony default export */ var EnrollmentCTA_EnrollmentCTA = (EnrollmentCTA);

/***/ }),

/***/ 76929:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ variant1_Help; }
});

// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(5616);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(65582);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Hidden/Hidden.js + 4 modules
var Hidden = __webpack_require__(50456);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 2 modules
var Link = __webpack_require__(23795);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(69417);
// EXTERNAL MODULE: ./node_modules/@care/material-ui-theme/dist/config/theme/theme.js + 68 modules
var theme = __webpack_require__(5136);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(18459);
// EXTERNAL MODULE: ./src/utils/AnalyticsHelper.ts
var AnalyticsHelper = __webpack_require__(10239);
;// CONCATENATED MODULE: ./src/assets/images/leads.png
/* harmony default export */ var leads = ({"src":"/app/hp-vhp/_next/static/media/leads.4f6749fb.png","height":250,"width":287,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAYAAAA1WQxeAAAAn0lEQVR42mOAgSzvMEYGJOBj4w/hR7vFwSX+n//A8n/3LXYGbOBK/bwl36duevVj3saPvxZsmg0UYllVUM/KcLRsMiuQw3O5dnbty+5Vn5/2Lf+6rbyrAigmuaeqj5mBQctBVUnfNQUoEGRo4hNmaxIQwMCs3Sul51zLoGzDxqBt6MbEwMDK9HnCRiYGCGDcWtrBwiBvwapu6MrIQAgAAHvHL+NUO2MsAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":7});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/pages/shared/Help/variant1/Help.tsx











var _ref = config_default()(),
    publicRuntimeConfig = _ref.publicRuntimeConfig;

var SERVICE_FAQ_URL = publicRuntimeConfig.SERVICE_FAQ_URL;

var Help = function Help() {
  var _theme$palette$care, _theme$palette$care2, _theme$palette$care3;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
    sx: {
      [theme/* theme.breakpoints.down */.rS.breakpoints.down('md')]: {
        height: '600px'
      },
      backgroundColor: (_theme$palette$care = theme/* theme.palette.care */.rS.palette.care) === null || _theme$palette$care === void 0 ? void 0 : _theme$palette$care.blue[100],
      height: '530px',
      textAlign: 'center'
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Container/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        container: true,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
          item: true,
          xs: 12,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
            display: "inline-flex",
            height: "250px",
            margin: "0 auto",
            position: "relative",
            width: "300px",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              alt: "Here to help",
              height: 250,
              layout: "intrinsic",
              loading: "lazy",
              src: leads,
              width: 300
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
              variant: "h1",
              sx: {
                margin: '16px 0px',
                position: 'absolute',
                textAlign: 'center',
                top: '181px',
                width: 'inherit'
              },
              children: "We're here to help"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* default */.Z, {
            variant: "body1",
            children: ["Our award-winning Tax, Payroll & HR specialists understand that every family's situation", /*#__PURE__*/(0,jsx_runtime.jsx)(Hidden/* default */.Z, {
              mdDown: true,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})
            }), "is unique. We are here to answer your questions quickly and accurately."]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* default */.Z, {
            m: 2,
            variant: "h3",
            children: ["Call us for a personalized consultation", ' ', /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
              component: "span",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                mdDown: true,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
                  variant: "h4",
                  color: (_theme$palette$care2 = theme/* theme.palette.care */.rS.palette.care) === null || _theme$palette$care2 === void 0 ? void 0 : _theme$palette$care2.blue[700],
                  component: "span",
                  children: constants/* PHONE_LABEL */.el
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Hidden/* default */.Z, {
                mdUp: true,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                  href: constants/* PHONE_LINK */.v,
                  passHref: true,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
                    color: (_theme$palette$care3 = theme/* theme.palette.care */.rS.palette.care) === null || _theme$palette$care3 === void 0 ? void 0 : _theme$palette$care3.blue[700],
                    variant: "h4",
                    href: constants/* PHONE_LINK */.v,
                    underline: "none",
                    children: constants/* PHONE_LABEL */.el
                  })
                })]
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
            m: "16px",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
              sx: {
                width: 'auto'
              },
              color: "secondary",
              "data-testid": "home-cta-review-faqs-btn",
              href: SERVICE_FAQ_URL,
              onClick: function onClick() {
                (0,AnalyticsHelper/* logAnalyticsEvent */.qw)({
                  data: {
                    cta_location: 'HomePay VHP',
                    cta_text: 'Review our FAQS'
                  },
                  name: AnalyticsHelper/* AmplitudeEventName.ctaInteracted */.LW.ctaInteracted,
                  pageProperties: constants/* PAGE_PROPERTIES.mainVHP */.vk.mainVHP
                });
              },
              variant: "contained",
              children: "Review our FAQs"
            })
          })]
        })
      })
    })
  });
};

/* harmony default export */ var variant1_Help = (Help);
;// CONCATENATED MODULE: ./src/components/pages/shared/Help/variant1/index.ts


/***/ }),

/***/ 41771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Testimonials_Testimonials; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(5616);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 2 modules
var Link = __webpack_require__(23795);
// EXTERNAL MODULE: ./node_modules/@mui/material/Hidden/Hidden.js + 4 modules
var Hidden = __webpack_require__(50456);
// EXTERNAL MODULE: ./node_modules/@care/material-ui-theme/dist/config/theme/theme.js + 68 modules
var theme = __webpack_require__(5136);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./src/components/pages/shared/ModalVideo/ModalVideo.tsx
var ModalVideo = __webpack_require__(75652);
// EXTERNAL MODULE: ./src/components/ui/index.ts + 9 modules
var ui = __webpack_require__(20935);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(18459);
// EXTERNAL MODULE: ./src/utils/hooks.ts
var hooks = __webpack_require__(18546);
// EXTERNAL MODULE: ./src/utils/AnalyticsHelper.ts
var AnalyticsHelper = __webpack_require__(10239);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/pages/shared/Testimonials/ClientReviews.tsx







var ClientReviews = function ClientReviews(_ref) {
  var reviews = _ref.reviews;
  var isMobile = (0,hooks/* useMobileQuery */.Lh)();
  var reviewCards = reviews.map(function (_ref2, index) {
    var _theme$palette$care;

    var author = _ref2.author,
        comment = _ref2.comment,
        location = _ref2.location;
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
      sx: {
        fontSize: '18px',
        lineHeight: '24px',
        margin: '0 auto',
        textAlign: 'center',
        width: '296px',
        [theme/* theme.breakpoints.up */.rS.breakpoints.up('md')]: {
          color: theme/* theme.palette.text.primary */.rS.palette.text.primary,
          marginTop: '24px',
          textAlign: 'left',
          width: 'auto'
        }
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
        children: comment
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* default */.Z, {
        color: (_theme$palette$care = theme/* theme.palette.care */.rS.palette.care) === null || _theme$palette$care === void 0 ? void 0 : _theme$palette$care.grey[500],
        variant: "body3",
        sx: {
          fontSize: '12px',
          marginLeft: '5px'
        },
        children: [author, location !== '' && ',', " ", location]
      })]
    }, index);
  });

  if (isMobile) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
      sx: {
        [theme/* theme.breakpoints.down */.rS.breakpoints.down('md')]: {
          height: '225px',
          margin: '0 auto'
        }
      },
      "data-testid": "reviews-wrapper",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Carousel */.lr, {
        children: reviewCards
      })
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
    "data-testid": "reviews-wrapper",
    children: reviewCards
  });
};

/* harmony default export */ var Testimonials_ClientReviews = (ClientReviews);
;// CONCATENATED MODULE: ./src/assets/images/fiverating.png
/* harmony default export */ var fiverating = ({"src":"/app/hp-vhp/_next/static/media/fiverating.5f3124e3.png","height":19,"width":116,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAIElEQVR4nGP8t4hvIgMDw24g1gHi50DMCMTiQHwViF0BcDEFQZ2bWYEAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":1});
;// CONCATENATED MODULE: ./src/components/pages/shared/Testimonials/Testimonials.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













var QuotesIcon = function QuotesIcon(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22.438 43.864c-2.41 2.18-5.388 3.27-8.935 3.27-3.866 0-7.083-1.536-9.65-4.61C1.283 39.45 0 35.075 0 29.4c0-5.202 1.125-10.076 3.376-14.621 2.25-4.546 5.004-8.145 8.26-10.799C14.893 1.327 17.792 0 20.333 0c1.695 0 3.019.5 3.972 1.498.953.998 1.43 2.285 1.43 3.862 0 2.312-1.033 4.02-3.098 5.123-2.807 1.524-5.03 3.31-6.672 5.36-1.642 2.05-2.568 4.624-2.78 7.724h1.112c3.018 0 5.732 1.143 8.141 3.429 2.41 2.286 3.614 5.137 3.614 8.552 0 3.363-1.204 6.135-3.614 8.316zm34.948.039c-2.41 2.26-5.388 3.39-8.936 3.39-3.918 0-7.148-1.577-9.69-4.73-2.541-3.153-3.812-7.54-3.812-13.163 0-4.046.662-7.856 1.986-11.429 1.323-3.573 3.031-6.687 5.123-9.34 2.091-2.654 4.342-4.756 6.751-6.306C51.218.775 53.375 0 55.281 0c1.748 0 3.085.486 4.011 1.458.927.972 1.39 2.273 1.39 3.902 0 2.364-1.032 4.072-3.097 5.123-2.913 1.63-5.11 3.429-6.593 5.4-1.482 1.97-2.383 4.532-2.7 7.684h1.032c2.965 0 5.653 1.143 8.062 3.429C59.796 29.282 61 32.133 61 35.548c0 3.31-1.205 6.096-3.614 8.355z",
      fill: "#FFCF0D"
    })
  }));
};

QuotesIcon.defaultProps = {
  width: "61",
  height: "48",
  viewBox: "-8 8 80 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};






var _ref = config_default()(),
    publicRuntimeConfig = _ref.publicRuntimeConfig;

var HOMEPAY_REVIEWS = publicRuntimeConfig.HOMEPAY_REVIEWS;

var Testimonials = function Testimonials(_ref2) {
  var _theme$palette$care;

  var title = _ref2.title,
      imageURI = _ref2.imageURI,
      reviews = _ref2.reviews,
      _ref2$hasClientStory = _ref2.hasClientStory,
      hasClientStory = _ref2$hasClientStory === void 0 ? true : _ref2$hasClientStory;

  var _useState = (0,react.useState)(false),
      isVisible = _useState[0],
      setVisibility = _useState[1];

  var isMobile = (0,hooks/* useMobileQuery */.Lh)();

  var toggleModalVisibility = function toggleModalVisibility() {
    return setVisibility(function (_isVisible) {
      return !_isVisible;
    });
  };

  var handleVideoButtonClick = function handleVideoButtonClick() {
    toggleModalVisibility();
    (0,AnalyticsHelper/* logAnalyticsEvent */.qw)({
      data: {
        cta_location: 'HomePay VHP',
        cta_text: 'Watch a Client Story'
      },
      name: AnalyticsHelper/* AmplitudeEventName.ctaInteracted */.LW.ctaInteracted,
      pageProperties: constants/* PAGE_PROPERTIES.mainVHP */.vk.mainVHP
    });
  };

  var handleReviewsClick = function handleReviewsClick() {
    (0,AnalyticsHelper/* logAnalyticsEvent */.qw)({
      data: {
        cta_location: 'Reviews',
        cta_text: 'ReadMoreReviewOnGoogle'
      },
      name: AnalyticsHelper/* AmplitudeEventName.ctaInteracted */.LW.ctaInteracted,
      pageProperties: constants/* PAGE_PROPERTIES.mainVHP */.vk.mainVHP
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
    container: true,
    spacing: 0,
    maxWidth: "xl",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
      sx: {
        '& span': {
          overflow: 'unset !important'
        },
        position: 'relative',
        width: '100%'
      },
      item: true,
      md: 5,
      sm: 12,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
          borderRadius: [0, 0, 2],
          [theme/* theme.breakpoints.up */.rS.breakpoints.up('md')]: {
            bottom: 'unset !important',
            left: 'unset !important',
            position: 'absolute',
            right: '-68px !important',
            top: '-48px !important',
            zIndex: 100
          }
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          alt: "Family depends",
          "data-testid": "testimonials-left-image",
          height: !isMobile ? 580 : 316,
          layout: isMobile ? 'responsive' : 'intrinsic',
          loading: "lazy",
          src: imageURI,
          width: !isMobile ? 568 : 375
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
          '& img': {
            left: '50% !important',
            top: '50% !important',
            transform: 'translate(-50%, -25%)'
          },
          [theme/* theme.breakpoints.up */.rS.breakpoints.up('md')]: {
            borderRadius: theme/* theme.spacing */.rS.spacing(6),
            bottom: 'unset',
            height: '100px',
            left: 'unset',
            right: '-105px',
            top: '180px',
            transform: 'translateX(0%)',
            width: '100px'
          },
          alignItems: 'center',
          backgroundColor: theme/* theme.palette.care.yellow.100 */.rS.palette.care.yellow[100],
          borderRadius: theme/* theme.spacing */.rS.spacing(5),
          bottom: '-28px',
          display: 'flex',
          height: theme/* theme.spacing */.rS.spacing(8),
          justifyContent: 'center',
          left: '50%',
          position: 'absolute',
          transform: 'translateX(-50%)',
          width: theme/* theme.spacing */.rS.spacing(8),
          zIndex: 101
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(QuotesIcon, {
          width: isMobile ? 55 : 80,
          height: isMobile ? 50 : 75,
          "data-testid": "testimonials-quotes-image"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
      sx: {
        width: '100%'
      },
      item: true,
      md: 7,
      sm: 12,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
          '& .Testimonials--google-url': {
            [theme/* theme.breakpoints.up */.rS.breakpoints.up('md')]: {
              alignItems: 'center',
              display: 'flex'
            }
          },
          '& h2': {
            fontSize: '28px',
            fontWeight: 'bold',
            lineHeight: '34px',
            margin: theme/* theme.spacing */.rS.spacing(0),
            paddingBottom: theme/* theme.spacing */.rS.spacing(2),
            [theme/* theme.breakpoints.up */.rS.breakpoints.up('md')]: {
              fontSize: '36px',
              lineHeight: '42px',
              margin: theme/* theme.spacing */.rS.spacing(0)
            }
          },
          [theme/* theme.breakpoints.up */.rS.breakpoints.up('md')]: {
            borderRadius: theme/* theme.spacing */.rS.spacing(2),
            height: 'auto',
            minHeight: 600,
            marginRight: 0,
            padding: theme/* theme.spacing */.rS.spacing(7, 4, 6, 16),
            textAlign: 'left'
          },
          backgroundColor: (_theme$palette$care = theme/* theme.palette.care */.rS.palette.care) === null || _theme$palette$care === void 0 ? void 0 : _theme$palette$care.grey[50],
          padding: theme/* theme.spacing */.rS.spacing(5, 0),
          textAlign: 'center'
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
          "data-testid": "testimonials-heading",
          variant: "h2",
          children: title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Testimonials_ClientReviews, {
          reviews: reviews
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
          mt: 5,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Link/* default */.Z, {
            className: "Testimonials--google-url",
            "data-testid": "testimonials-google-url",
            href: "".concat(HOMEPAY_REVIEWS),
            onClick: handleReviewsClick,
            underline: "none",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              alt: "More reviews",
              height: 19,
              layout: "fixed",
              loading: "lazy",
              src: fiverating,
              width: 128
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Hidden/* default */.Z, {
              smUp: true,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
              component: "span",
              pl: 1,
              children: "Read more reviews >"
            })]
          })
        }), hasClientStory && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
            mt: 4,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* PlayButtonLink */.e3, {
              "data-testid": "watch-story-link",
              onClick: handleVideoButtonClick,
              children: "Watch a client story"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ModalVideo/* default */.Z, {
            dataTestId: "homepage-how-homepay-helps-modal",
            isVisible: isVisible,
            onClose: toggleModalVisibility,
            title: "How Care.com HomePay helps",
            videoUrl: constants/* HOW_HP_HELPS_VIDEO_URL */.qB
          })]
        })]
      })
    })]
  });
};

/* harmony default export */ var Testimonials_Testimonials = (Testimonials);
;// CONCATENATED MODULE: ./src/components/pages/shared/Testimonials/index.ts


/***/ }),

/***/ 86229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useGTMTracking; },
/* harmony export */   "t": function() { return /* binding */ GTMEvent; }
/* harmony export */ });
/* harmony import */ var _usr_src_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_UserProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44979);
/* harmony import */ var _utils_AnalyticsHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10239);
/* harmony import */ var _utils_GtmService__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22768);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_usr_src_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable @typescript-eslint/no-unsafe-assignment */




var GTMEvent;

(function (GTMEvent) {
  GTMEvent["VIEW"] = "View";
  GTMEvent["HOMEPAY_NANNY_TAX_CALCULATOR_LEAD"] = "homepay_nanny_tax_calculator_lead";
})(GTMEvent || (GTMEvent = {}));

function useGTMTracking(options) {
  var pageProperties = options.pageProperties,
      _options$slots = options.slots,
      slots = _options$slots === void 0 ? [] : _options$slots,
      _options$data = options.data,
      data = _options$data === void 0 ? {} : _options$data,
      _options$fireOnMount = options.fireOnMount,
      fireOnMount = _options$fireOnMount === void 0 ? true : _options$fireOnMount,
      _options$event = options.event,
      event = _options$event === void 0 ? GTMEvent.VIEW : _options$event;

  var _useUserAuth = (0,_components_UserProvider__WEBPACK_IMPORTED_MODULE_2__/* .useUserAuth */ .Ii)(),
      auth = _useUserAuth.auth;

  var gtmData = _objectSpread(_objectSpread(_objectSpread({}, data), (auth === null || auth === void 0 ? void 0 : auth.isLoggedIn) && {
    memberId: auth.memberUuid
  }), {}, {
    gtmEvent: event,
    event,
    slots
  });

  var logSlotsSent = function logSlotsSent(eventProps) {
    (0,_utils_AnalyticsHelper__WEBPACK_IMPORTED_MODULE_3__/* .logAnalyticsEvent */ .qw)({
      data: eventProps,
      name: _utils_AnalyticsHelper__WEBPACK_IMPORTED_MODULE_3__/* .AmplitudeEventName.slotSent */ .LW.slotSent,
      pageProperties
    });
  };

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (fireOnMount) {
      _utils_GtmService__WEBPACK_IMPORTED_MODULE_4__/* .GtmService.pushEvent */ .b.pushEvent(gtmData);
      logSlotsSent(_objectSpread(_objectSpread({}, data), {}, {
        slots,
        event
      }));
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  return function () {
    var triggerSlots = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var triggerData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var ctaData = arguments.length > 2 ? arguments[2] : undefined;
    _utils_GtmService__WEBPACK_IMPORTED_MODULE_4__/* .GtmService.pushEvent */ .b.pushEvent(_objectSpread(_objectSpread(_objectSpread({}, gtmData), triggerData), {}, {
      slots: triggerSlots
    }));
    logSlotsSent(_objectSpread(_objectSpread(_objectSpread({}, data), triggerData), {}, {
      slots: triggerSlots,
      event
    }));
    (0,_utils_AnalyticsHelper__WEBPACK_IMPORTED_MODULE_3__/* .logAnalyticsEvent */ .qw)({
      data: _objectSpread(_objectSpread(_objectSpread({}, ctaData), data), triggerData),
      name: _utils_AnalyticsHelper__WEBPACK_IMPORTED_MODULE_3__/* .AmplitudeEventName.ctaInteracted */ .LW.ctaInteracted,
      pageProperties
    });
  };
}

/***/ }),

/***/ 68796:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/app/hp-vhp/_next/static/media/headset.48abdf15.png","height":136,"width":136,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAsElEQVR42mPABUS1HRlRBIIMHcUSTJwUgw0dFW31HHlBYi76UEU+Bo5CDAwOYnDVSo6yy12cIJL/Y12YGIQd9U76Opc8CnFecyfIeds0BydHBgVHJbCCLDMnUQY1x71HfJx7XoY5/38d7vws08xpEYOm40SwAkUdRxYdXUcLEHuvl3Mz0KRgBlFHI0s9RzMGDCDlaMKg4hg20c6RBcRV13WC+kTLkSnRBMqBAh1diA8AxCooEP/7dxgAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});

/***/ })

}]);